import { InfoIcon } from "@chakra-ui/icons";

export const needsReviewIconProps = {
  as: InfoIcon,
  color: "warning.300",
};

export const transactionTooltipText =
  "Syla has some suggestions to help improve your tax outcome";

export const sylaSuggestionsText = "Syla Suggestions";
